import React from "react";
import { format } from "date-fns";

// Format date to DD.MM (without year)
const formatDate = (date) => {
    if (!date) return "";
    try {
        const d = date instanceof Date ? date : new Date(date);
        return format(d, "dd.MM");
    } catch (error) {
        return "";
    }
};

const TaskTemplateComponent = ({ data }) => {
    // Format date range for display on the bar
    const getDateRange = () => {
        const startStr = formatDate(data.start);
        const endStr = formatDate(data.end);
        if (startStr && endStr) {
            return `${startStr} - ${endStr}`;
        }
        return data.text || "";
    };

    return (
        <>
            {data.type === "milestone" ? (
                <span>{formatDate(data.start) || data.text || ""}</span>
            ) : (
                <span>{getDateRange()}</span>
            )}
        </>
    );
};

export default TaskTemplateComponent;
